var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('nav-menu', _vm._g(_vm._b({
    attrs: {
      "name": "Group greeting cards",
      "title": "Send any card as a group greeting card",
      "subtitle": "Invite your group to sign remotely",
      "action": "View all cards",
      "icon": _vm.mdiCards,
      "to": {
        name: 'catalog',
        query: {
          type: 'GROUP'
        }
      }
    }
  }, 'nav-menu', _vm.$attrs, false), _vm.$listeners), [_c('div', {
    staticClass: "pa-3 d-flex flex-column-reverse d-sm-block"
  }, [_c('div', {
    staticClass: "mt-3 mt-sm-0 float-sm-right",
    style: {
      width: _vm.$vuetify.breakpoint.xsOnly ? '100%' : '320px'
    }
  }, [_c('div', {
    staticClass: "mb-2 caption"
  }, [_vm._v("Perfect for "), _c('router-link', {
    attrs: {
      "to": {
        name: 'business'
      }
    }
  }, [_vm._v("business")]), _vm._v(" (remote or in-person)")], 1), _c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-responsive', {
    attrs: {
      "aspect-ratio": 16 / 9
    }
  }, [_c('video', {
    staticClass: "d-block",
    attrs: {
      "width": "100%",
      "playsinline": "",
      "autoplay": "autoplay",
      "muted": "muted",
      "loop": "loop",
      "src": "https://cdn.ellacard.com/nav/group_cards_320x246.mp4"
    },
    domProps: {
      "muted": true
    }
  })])], 1), _c('div', {
    staticClass: "mt-2 mb-3 caption"
  }, [_vm._v("Unlimited contributors, unlimited pages. Scheduled send via "), _c('span', {
    staticClass: "green--text"
  }, [_vm._v("email")]), _vm._v(" or "), _c('span', {
    staticClass: "green--text"
  }, [_vm._v("text message")]), _vm._v(".")])], 1), _c('div', [_c('div', {
    staticClass: "caption"
  }, [_vm._v("Group cards for any occasion")]), _vm._l([['Birthdays', 'Birthday', _vm.mdiCakeVariant], ['Welcome to the team', 'Welcome', _vm.mdiAccountGroup], ['Kudos / congrats', 'Congrats', _vm.mdiPartyPopper], ['Work anniversaries', 'Work Anniversary', _vm.iconPathWorkAnniversary], ['Retirement', 'Retirement', _vm.mdiBriefcaseCheck], ['Condolences', 'Condolences', _vm.mdiEmoticonSad], ['Design your own…', ['Template', 'blank'], _vm.mdiPencilBoxOutline]], function (_ref) {
    var name = _ref[0],
        q = _ref[1],
        icon = _ref[2];
    return _c('div', {
      staticClass: "mx-n2"
    }, [_c('v-btn', {
      attrs: {
        "text": "",
        "color": "primary",
        "to": {
          name: 'catalog',
          query: {
            q: q,
            type: 'GROUP'
          }
        }
      }
    }, [_c('v-icon', {
      staticClass: "mr-1",
      attrs: {
        "small": ""
      },
      domProps: {
        "innerHTML": _vm._s(icon)
      }
    }), _vm._v(_vm._s(name) + " ")], 1)], 1);
  }), !_vm.global.xgc ? [_c('div', {
    staticClass: "mt-3 caption"
  }, [_vm._v("Contribute to group gift cards")]), _c('div', {
    staticClass: "mx-n2"
  }, [_c('v-btn', {
    attrs: {
      "text": "",
      "color": "primary",
      "to": {
        name: 'catalog-gift-cards'
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "small": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiWalletGiftcard)
    }
  }), _vm._v("View all gift cards ")], 1)], 1)] : _vm._e()], 2)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }